import React, { useEffect, useState } from "react";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select as MUISelect,
  SelectChangeEvent,
  SelectProps,
  IconButton,
  InputAdornment,
  Autocomplete,
  TextField,
} from "@mui/material";
import clsx from "clsx";
import { Icon } from "../Icon";
import Spinner from "../Spinner";
import { useTranslation } from "react-i18next";

export type OptionType = {
  value: string | number;
  name: string | number;
};

interface MultipleSelectTypes
  extends Omit<SelectProps, "onChange" | "multiple" | "value"> {
  options?: OptionType[];
  onChange?: (selected: OptionType[], name?: string) => void;
  initialValue?: OptionType[];
  reference?: any;
  onClear?: () => void;
  isError?: boolean;
  loading?: boolean;
  shrink?: boolean;
}

export function MultipleSelect({
  onChange,
  options = [],
  initialValue = [],
  className,
  label,
  onClear,
  reference,
  name,
  size = "small",
  isError = false,
  loading = false,
  shrink,
  disabled,
  ...rest
}: MultipleSelectTypes) {
  const { t } = useTranslation();
  // Always ensure state is an array
  const [selectedOptions, setSelectedOptions] = useState<OptionType[]>(
    Array.isArray(initialValue) ? initialValue.map((i) => i) : []
  );
  const [inputValue, setInputValue] = useState<string>("");

  // Notify parent on change
  useEffect(() => {
    // const selectedOptions = options.filter((opt) =>
    //   selectedValues.includes(opt.value)
    // );
    onChange?.(selectedOptions, name);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOptions]);
  //
  // // Update if initialValue changes
  // useEffect(() => {
  //   if (Array.isArray(initialValue)) {
  //     setSelectedOptions(initialValue.map((i) => i));
  //   } else {
  //     setSelectedOptions([]);
  //   }
  // }, [initialValue]);

  const handleChange = (event: SelectChangeEvent<OptionType[]>) => {
    const value = event.target.value as OptionType[];
    // MUI might pass a string in some cases (e.g., autofill)
    setSelectedOptions(value);
  };

  const handleClear = () => {
    setSelectedOptions([]);
    onClear?.();
  };

  // return (
  //   <FormControl
  //     className={clsx(className, disabled && "opacity-50 cursor-not-allowed")}
  //     size={size !== "small" ? "medium" : size}
  //   >
  //     <InputLabel error={isError} id={`${name}-label`} shrink={shrink}>
  //       {label}
  //     </InputLabel>
  //
  //     <MUISelect
  //       labelId={`${name}-label`}
  //       multiple
  //       value={selectedValues ?? []} // ✅ always an array
  //       onChange={handleChange}
  //       disabled={disabled}
  //       error={isError}
  //       inputRef={reference}
  //       renderValue={(selected) => {
  //         if (!selected.length) return "";
  //         const selectedNames = options
  //           .filter((opt) => selected.includes(opt.value))
  //           .map((opt) => opt.name);
  //         return selectedNames.join(", ");
  //       }}
  //       startAdornment={
  //         loading && (
  //           <InputAdornment position="start" className="ml-4">
  //             <Spinner size={14} />
  //           </InputAdornment>
  //         )
  //       }
  //       endAdornment={
  //         onClear &&
  //         selectedValues.length > 0 && (
  //           <InputAdornment position="end" className="ml-4">
  //             <IconButton onClick={handleClear} size="small">
  //               <Icon icon="MdClear" />
  //             </IconButton>
  //           </InputAdornment>
  //         )
  //       }
  //       className={clsx("w-full", disabled && "cursor-not-allowed")}
  //       {...rest}
  //     >
  //       {options.map((item, index) => (
  //         <MenuItem key={index} value={item.value}>
  //           {item.name}
  //         </MenuItem>
  //       ))}
  //     </MUISelect>
  //   </FormControl>
  // );

  return (
    <Autocomplete
      multiple
      className={className}
      disableCloseOnSelect
      sx={{ minWidth: 250 }}
      loading={loading}
      options={options}
      value={selectedOptions}
      onChange={(_, newValue) => setSelectedOptions(newValue)}
      getOptionLabel={(option) => String(option.name) || ""}
      filterOptions={(x) => x}
      inputValue={inputValue}
      onInputChange={(_, newInputValue) => setInputValue(newInputValue)}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      renderInput={(params) => (
        <TextField
          {...params}
          onChange={() => {}}
          size={size}
          label={label}
          placeholder={t("search")}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {loading ? <Spinner size={16} /> : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
          error={isError}
        />
      )}
    />
  );
}
